import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.AlignedFieldsRadioGroup
      @title='Mobilité selon la classification ABM'
      @propertyName='abmClassification'
      as |Group|
    >
      <Group.FieldRadio @label='Incapacité totale ' @value='total_incapacity' />
      <Group.FieldRadio
        @label='Nécessité tierce personne'
        @value='third_party_need'
      />
      <Group.FieldRadio @label='Marche autonome' @value='autonomous_walk' />
    </@form.AlignedFieldsRadioGroup>
  </div>

  <div class='field'>
    <label>
      Autres informations
    </label>

    <div class='field'>
      <@form.Checkbox
        @labelName='Risque immunologique'
        @payloadKey='immunologicalRisk'
      />
    </div>

    <div class='field'>
      <@form.Checkbox
        @labelName='ABO incompatible'
        @payloadKey='incompatibleABO'
      />
    </div>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
